import React from "react";

export const BNR_SOCIAL_LINKS = [
  {
    id: "x",
    href: "https://x.com/CentralBankRw",
    label: "National Bank of Rwanda on X",
    icon: "x",
  },
  {
    id: "facebook",
    href: "https://www.facebook.com/CentralBankRw/",
    label: "National Bank of Rwanda on Facebook",
    icon: "facebook",
  },
  {
    id: "linkedin",
    href: "https://www.linkedin.com/company/national-bank-of-rwanda-bnr-",
    label: "National Bank of Rwanda on LinkedIn",
    icon: "linkedin",
  },
  {
    id: "youtube",
    href: "https://www.youtube.com/channel/UCNL-AuMdkEhr_FnfeT0BKRQ",
    label: "National Bank of Rwanda on YouTube",
    icon: "youtube",
  },
];

const IconX = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    aria-hidden="true"
    className="bnr-header-social__icon-svg"
  >
    <path
      fill="currentColor"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
);

function SocialIcon({ icon }) {
  if (icon === "x") return <IconX />;
  if (icon === "facebook") return <i className="fab fa-facebook-f" aria-hidden="true" />;
  if (icon === "linkedin") return <i className="fab fa-linkedin-in" aria-hidden="true" />;
  if (icon === "youtube") return <i className="fab fa-youtube" aria-hidden="true" />;
  return null;
}

export default function BnrSocialLinks({ className = "" }) {
  return (
    <nav className={`bnr-header-social ${className}`.trim()} aria-label="BNR social media">
      {BNR_SOCIAL_LINKS.map((item) => (
        <a
          key={item.id}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className="bnr-header-social__link"
          aria-label={item.label}
        >
          <SocialIcon icon={item.icon} />
        </a>
      ))}
    </nav>
  );
}
